export default __webpack_public_path__ + "static/michals-33697a3ecee2f132ec155388812d3681.jpg";